import React from "react";
import {
  FaCloud,
  FaDatabase,
  FaMobileAlt,
  FaLaptopCode,
  FaCheckCircle,
} from "react-icons/fa";

const heroImg =
  "https://tse4.mm.bing.net/th/id/OIP.3G9EwaPLMOuujddKOKG9AwHaEj?pid=Api&P=0&h=180";

const webDevImg =
  "https://images.unsplash.com/photo-1555066931-4365d14bab8c?auto=format&fit=crop&w=800&q=80";

const appImg =
  "https://images.unsplash.com/photo-1511707171634-5f897ff02aa9?auto=format&fit=crop&w=800&q=80";

const cloudImg =
  "https://images.unsplash.com/photo-1515378791036-0648a3ef77b2?auto=format&fit=crop&w=800&q=80";

const backendImg =
  "https://images.unsplash.com/photo-1556155092-490a1ba16284?auto=format&fit=crop&w=800&q=80";

const It = () => {
  return (
    <div className="w-full bg-slate-900 text-white">
      
      {/* HERO SECTION */}
      <div className="relative w-full h-[70vh] animate-fadeIn">
        <img
          src={heroImg}
          alt="IT Solutions"
          className="w-full h-full object-cover opacity-40"
        />
        <div className="absolute inset-0 flex flex-col justify-center items-center text-center px-6">
          <h1 className="text-4xl md:text-6xl font-bold drop-shadow-lg animate-slideDown">
            IT & Web Solutions
          </h1>
          <p className="text-slate-300 text-lg md:text-xl mt-4 max-w-3xl animate-fadeInSlow">
            We build modern, fast, secure and scalable digital solutions —
            from websites to cloud infrastructure and enterprise-level software.
          </p>
        </div>
      </div>

      {/* SERVICES */}
      <div className="max-w-6xl mx-auto px-6 py-16">
        <h2 className="text-3xl font-bold text-center animate-slideUp">
          Our IT Expertise
        </h2>

        <div className="mt-10 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          
          {/* Web Development */}
          <div className="bg-slate-800 p-6 rounded-xl shadow-lg hover:-translate-y-2 duration-300 hover:shadow-2xl">
            <img src={webDevImg} className="rounded-lg mb-4" alt="Web Dev" />
            <h3 className="text-xl font-bold flex items-center gap-2">
              <FaLaptopCode /> Web Development
            </h3>
            <p className="text-slate-300 mt-2">
              Modern websites, business portals, dashboards with React, Node,
              Express, Tailwind and more.
            </p>
          </div>

          {/* App Development */}
          <div className="bg-slate-800 p-6 rounded-xl shadow-lg hover:-translate-y-2 duration-300 hover:shadow-2xl">
            <img src={appImg} className="rounded-lg mb-4" alt="Mobile App" />
            <h3 className="text-xl font-bold flex items-center gap-2">
              <FaMobileAlt /> App Development
            </h3>
            <p className="text-slate-300 mt-2">
              Android & iOS mobile apps with smooth UI and powerful backend.
            </p>
          </div>

          {/* Cloud Services */}
          <div className="bg-slate-800 p-6 rounded-xl shadow-lg hover:-translate-y-2 duration-300 hover:shadow-2xl">
            <img src={cloudImg} className="rounded-lg mb-4" alt="Cloud" />
            <h3 className="text-xl font-bold flex items-center gap-2">
              <FaCloud /> Cloud Deployment
            </h3>
            <p className="text-slate-300 mt-2">
              AWS, Azure, Google Cloud setup, CI/CD pipelines, serverless apps.
            </p>
          </div>

          {/* Backend */}
          <div className="bg-slate-800 p-6 rounded-xl shadow-lg hover:-translate-y-2 duration-300 hover:shadow-2xl">
            <img src={backendImg} className="rounded-lg mb-4" alt="Backend" />
            <h3 className="text-xl font-bold flex items-center gap-2">
              <FaDatabase /> Backend & Database
            </h3>
            <p className="text-slate-300 mt-2">
              Secure APIs, MySQL, MongoDB, PostgreSQL, authentication & more.
            </p>
          </div>

        </div>
      </div>

      {/* TECHNOLOGIES */}
      <div className="bg-slate-800 py-12 mt-6">
        <h2 className="text-3xl font-bold text-center">Technologies We Use</h2>

        <div className="flex flex-wrap justify-center gap-6 mt-6 text-lg text-slate-300">
          <p>React</p>
          <p>Node.js</p>
          <p>MongoDB</p>
          <p>MySQL</p>
          <p>Tailwind CSS</p>
          <p>AWS</p>
          <p>Firebase</p>
          <p>Docker</p>
          <p>Java</p>
          <p>Python</p>
          <p>C</p>
          <p>C++</p>
        </div>
      </div>

      {/* Why Choose Us */}
      <div className="bg-slate-800 py-16">
        <h2 className="text-3xl font-bold text-center">Why Choose Us?</h2>

        <div className="max-w-5xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-8 mt-10">
          <div className="flex items-start gap-4">
            <FaCheckCircle className="text-blue-400 text-3xl" />
            <p>Experienced full-stack developers</p>
          </div>

          <div className="flex items-start gap-4">
            <FaCheckCircle className="text-blue-400 text-3xl" />
            <p>Clean UI, fast performance, modern designs</p>
          </div>

          <div className="flex items-start gap-4">
            <FaCheckCircle className="text-blue-400 text-3xl" />
            <p>Complete end-to-end IT & cloud support</p>
          </div>

          <div className="flex items-start gap-4">
            <FaCheckCircle className="text-blue-400 text-3xl" />
            <p>Affordable & business-friendly pricing</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default It;
